import { Component, OnInit } from '@angular/core';


@Component({
	selector: 'app-articles-and-volumes',
	templateUrl: './articles-and-volumes.component.html',
	styleUrls: ['./articles-and-volumes.component.css']
})
export class ArticlesAndVolumesComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}
}